/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState } from "react";

import { Row, Col, Table } from "react-bootstrap";

import { useAuth } from "../../components/AuthProvider"



function Debugger(props) {
  const results = useAuth();

  let s = describeObject(results, "results");
  let t = results.simResults;

  let time_style = {
    paddingRight: "10px"
  }


  return (
    <>
      <Row>
        <Col><h3>Debugger</h3></Col>
      </Row>

      <Row>
        <Col>
           <span style={time_style}>{t.setupTime}</span>
           <span style={time_style}>{t.genTime}</span>
           <span style={time_style}>{t.sortTime}</span>
           <span style={time_style}>{t.calcTime}</span>
        </Col>
        <Col>
          <Download simModel={t.simModel} timeline={t.timeSpan}/>        
        </Col>
      </Row>

      <Row>
        <Col xs={3}><pre>{JSON.stringify(results.currentModel, null, 2)}</pre></Col>
        <Col><RenderObject obj={s} /></Col>
      </Row>

    </>
  );
}
/*

      <Row>
        <Col><pre>{JSON.stringify(s, null, 2)}</pre></Col>
      </Row>

*/


function RenderObject(props) {
  const [display, setDisplay] = useState(false);
  const r = props.obj;

  if (r === null) {
    return null;
  }


  function toggleInfo(event) {
    event.preventDefault();
    setDisplay(!display);
  }


  const div_style = {
    backgroundColor: "lightgrey",
    padding: "2px"
    //paddingLeft: "15px"
  }

  const name_style = {
    color: "darkblue",
  }

  let icon = display === true ? '-' : '+';


  return (
    <div style={div_style}>
      <span onClick={toggleInfo}>{icon}</span>&nbsp;<span style={name_style}>{r.name} {'{}'}</span>
      <RenderNode node={r} display={display} />
    </div>
  );
}


function RenderArray(props) {
  const [display, setDisplay] = useState(false);
  const f = props.array;


  function toggleInfo(event) {
    event.preventDefault();
    setDisplay(!display);
  }


  const name_style = {
    color: "blue",
    paddingRight: "10px"
  }
  const type_style = {
    color: "darkgreen",
  }

  let icon = display === true ? '-' : '+';


  return (
    <div>
      <span style={name_style}>{f.name}:</span><span style={type_style}>{`[${f.len}]`}</span><span onClick={toggleInfo}>{icon}</span>
      <RenderNode node={f.info} display={display} />
    </div>

  )
}


function RenderField(props) {
  const f = props.field;

  const name_style = {
    color: "blue",
    paddingRight: "10px"
  }
  const type_style = {
    color: "darkgreen",
  }


  return (
    <div>
      <span style={name_style}>{f.name}:</span><span style={type_style}>{f.type}</span>
    </div>

  )
}


function RenderNode(props) {
  const n = props.node;

  if (n === null) {
    return null;
  }

  const info_style = {
    paddingLeft: "12px",
    display: props.display === true ? 'block' : 'none'
  }

  
  if (!n.isObj) {
    return (
      <div style={info_style}>
        {n.name}
      </div>
    )
  }

  if (n.isEmpty) {
    return (
      <div style={info_style}>
        Empty
      </div>
    )
  }


  return (
    <div style={info_style}>

      {n.fields.map(f => <RenderField key={f.name} field={f} />)}

      {n.arrays.map(a => <RenderArray key={a.name} array={a} />)}

      {n.objects.map(o => <RenderObject key={o.name} obj={o.info} />)}
    </div>
  );

}




function describeObject(root, name) {
  let symbols = {
    seen: []
  };

  return walkObject(symbols, name, root, 0);
}


// 16-Feb-2024 JC 
// TODO - refactor into pure AST 
// This is sloppy as fuck. Its sort of a hybrid of an AST and laziness, will
// do for now but needs refactoring do remove assumption everything is an object
// at every node
function walkObject(symbols, name, node, depth) {
  if (node === undefined || node === null) {
    return null;
  }

  // See if we seen this object before
  let sym = symbols.seen.find(s => Object.is(s.node, node));
  if (sym !== undefined) {
    return sym.schema;
  }


  let schema = makeSchemaNode(name);
  symbols.seen.push({ node, schema });


  //console.log(depth);
  for (const [key, value] of Object.entries(node)) {
    let t = typeof value;

    if (t === 'string' || t === 'number' || t === 'boolean') {
      schema.fields.push(makeVar(key, t));
    } else if (t === 'object') {
      if (Array.isArray(value)) {

        if (key === 'allNames') { // TODO - debug remove
          let x = 0;
        }

        // TODO handle literal types as values in an array
        let a = makeArray(key)
        a.len = value.length;
        schema.arrays.push(a);

        if (value.length > 0) {
          let c = value[0];
          let v = typeof c;

          if (v === 'object') {
            a.info = walkObject(symbols, key, c, depth + 1);
            // If we encounter an empty object, see if there are any more candidates
            // in the array and walk one more
            if (a.info.isEmpty && value.length > 1) {
              a.info = walkObject(symbols, key, value[1], depth + 1);
            }
          } else {
            let tn = "YY"; // unknown
            if (v === 'string' || v === 'number' || v === 'boolean') {
              tn = v;
            } 

            let s = makeSchemaNode(tn);
            s.isObj = false;
            a.info = s;
          }
        }
      } else if (value instanceof Date) {
        schema.fields.push(makeVar(key, "date"));
      } else {
        let o = makeObject(key);
        schema.objects.push(o)
        o.info = walkObject(symbols, key, value, depth + 1);
      }
    } else {
      schema.fields.push(makeVar(key, "xxx"));
    }
  }

  if (schema.arrays.length === 0 && schema.objects.length === 0 && schema.fields.length === 0) {
    schema.isEmpty = true;
  }

  return schema;
}


function makeSchemaNode(name) {
  // By defaults its an object, but need to handle literal types
  // in arrays, so adding isObj flag, and will use name as type :)
  let schema = {
    isObj: true,
    name: name,
    isEmpty: false,
    fields: [],
    arrays: [],
    objects: []
  }

  return schema;
}


function makeVar(name, type) {
  return makeNode(name, type);
}

function makeArray(name) {
  return makeNode(name, "array");
}

function makeObject(name) {
  return makeNode(name, "object");
}

function makeNode(name, type) {
  return { name, type, info: null, len: -1 };
}





function Download(props) {

  function makeData() {
    let timeline = props.timeline;
    let model = props.simModel;

    let data = [];

    function makeRow(label) {
      let r = [];

      r.push(label);
      data.push(r);

      return r;
    }


    let t = timeline.timeline;
    let len = t.length;

    let y_row = makeRow("Year"); 
    let m_row = makeRow("Month"); 
    let p_row = makeRow("Period"); 

    let ms_rows = [];
    let sb_row = makeRow("Start"); 
    let de_row = makeRow("Delinquant"); 
    for ( let s=0; s<timeline.grandTotal.groupTotals.length; s++) {
      let row = makeRow(model.categoryTypes[s].code);

      ms_rows.push(row);
    }

    
    for ( let i=0; i<len; i++) {
      const m = t[i];
 
      y_row.push(m.year);
      m_row.push(m.monthLabel);
      p_row.push(m.periodIndex);

      const ms = m.monthTotals;
      for ( let s=0; s<ms.groupTotals.length; s++) {
        ms_rows[s].push(ms.groupTotals[s]);
      }
      sb_row.push(ms.calendarStartBal);
      de_row.push(ms.monthDelinquent);
    }


    return data;
  }


  function makeCSV(data) {
    let csv = "";

    let len = data.length;
    for ( let i=0; i<len; i++) {
      const r = data[i];
      const l = r.length;

      let row = "";
      for ( let j=0; j<l; j++) {
        row += r[j].toString() + ",";
      }

      row += "\r\n";

      csv += row;
    }

    return csv;
  }


  function onDownload(event) {
    event.preventDefault();

    let data = makeData();
    let csv = makeCSV(data);

    const element = document.createElement("a");
    const file = new Blob([csv], { type: 'text/csv' });
    element.href = URL.createObjectURL(file);
    element.download = "myFile.csv";
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
  }


  return (
    <div>
      <button onClick={onDownload}>Download txt</button>
    </div>
  );
}




export default Debugger;
